import api from "./api";

const ChatService = {
  /**
   * Sends a message to the AI chatbot and receives a response.
   * @param {string} message The user's message to send to the AI.
   * @returns {Promise<Object>} A promise that resolves to the AI response.
   */
  sendMessage: async (message) => {
    try {
      const response = await api.post("/gemini/chat", { message });
      return response.data;
    } catch (error) {
      console.error("Error sending message to AI:", error);
      throw error;
    }
  },

  /**
   * Sends a message with conversation history for context.
   * @param {string} message The user's message.
   * @param {Array} history Previous conversation history (optional).
   * @returns {Promise<Object>} A promise that resolves to the AI response.
   */
  sendMessageWithHistory: async (message, history = []) => {
    try {
      const response = await api.post("/gemini/chat", {
        message,
        history,
      });
      return response.data;
    } catch (error) {
      console.error("Error sending message with history to AI:", error);
      throw error;
    }
  },

  /**
   * Checks if the chat service is available.
   * @returns {Promise<Object>} A promise that resolves to service status.
   */
  checkServiceStatus: async () => {
    try {
      const response = await api.get("/gemini/status");
      return response.data;
    } catch (error) {
      console.error("Error checking chat service status:", error);
      throw error;
    }
  },
};

export default ChatService;
